import { Toast as ToastPrimitive } from 'radix-ui'
import type { ReactNode } from 'react'
import s from './Toast.module.css'

type ToastProviderProps = {
  children?: ReactNode
}

/**
 * Только компоненты: контекст Radix + стилизованный `Viewport`. Очередь тостов и императивный
 * API (`toast.error(...)`, `toast.success(...)`) — Task 18, не эта задача (план фазы 1 называет
 * его «Task 10» в двух местах, это опечатка, сверено с самим планом:
 * docs/superpowers/plans/2026-07-11-phase-1-foundation-and-shell.md:4510-4527 — именно там
 * заведён zustand-стор и `<Toaster />`, использующие «компоненты из Task 5», то есть этот файл).
 *
 * `children` необязателен, а не оборачивает всё приложение: `<ToastProvider />` самодостаточен
 * (так и дан в Interfaces брифа — самозакрывающимся тегом), `<Toast>` потребитель размещает где
 * угодно внутри него позже — `Toast.Root` порталится в `Viewport` сам, независимо от места
 * в дереве JSX (node_modules/@radix-ui/react-toast/dist/index.mjs:370-381).
 */
export function ToastProvider({ children }: ToastProviderProps) {
  return (
    <ToastPrimitive.Provider label="Уведомление" duration={5000} swipeDirection="right">
      {children}
      <ToastPrimitive.Viewport className={s.viewport} label="Уведомления ({hotkey})" />
    </ToastPrimitive.Provider>
  )
}
